const userDashboardDictEN = {
  dashboard: "Dashboard",
  userDashboard: "User Dashboard",
  wallet: "Wallet",
  transfer: "Transfer",
  transferRequests: "Transfer Requests",
  productServices: "Products and Services",
  maxBalanceReached: "You have reached your maximum balance.",
  new: "New",
  dropshipping: "Dropshipping",
  list: "List",
  sales: "Sales",
  purchases: "Purchases",
  network: "Economic Circle",
  directs: "Directs",
  all: "All",
  coupons: "Coupons",
  attributes: "Attributes",
  withdraw: "Withdraw",
  yourStore: "Your Store",
  favorites: "Favorites",
  isService: "Is this subcategory a service?",
  importProducts: "Import Products",
  pageNotFound: "Page not found",
  popupHeader1: "You have",
  popupHeader2: "day(s) left to expire your subscription",
  subscriptionExpirationDate: "Subscription expiration date",
  wantToRenewSubscription: "Do you want to renew your subscription?",
  subscription: "Subscription",
  renewSubscription: "Renew Subscription",
  payWithPaypal: "Pay with Paypal",
  walletBalancerRenew: "Wallet Balance",
  paymentMethods: "Payment Methods",
  errorRenewingSubscription: "There was an error renewing your subscription, try again",
  youWantRenewWalletBalance: "Do you want to renew with the wallet balance?",
  subscriptionRenewed: "Subscription renewed successfully!",
  yourSubcriptionExpired: "Your subscription has expired",
  wantToRenewyourSubscription: "Do you want to renew it?",
  unfavorite: "Unfavorite",
  waitLabel:
    "Wait for your label to be generated. Just press the button below when your order is picked up by the carrier.",
  freeRenewalsRemaining: "Free Renewals Remaining",
  BOZZA: "Waiting for approval",
  INSPEDIZIONE: "In transit",
  RITIRORICHIESTO: "Pickup requested",
  CONSEGNATA: "Delivered",
  errorDownloadLabel: "There was an error creating the label",
  nextAction: "Next",
  closeAction: "Close",
  backAction: "Back",
  welcomeToExtraconomy: "Welcome to Extraconomy",
  dashboardWelcomeMessage: "Welcome to ",
  ifYouWantToSellOnExtraconomy:
    "If you want to sell on Extraconomy, then follow the steps to learn how to create your store and your products",
  registerYourAddress: "Register your address",
  initiallyYouNeedToRegisterYourAddress:
    "Initially you need to register your address so that we can use it for deliveries",
  fillInYourContactPhoneNumber: "Fill in your contact phone number",
  fillInYourContactNumber: "Fill in your contact phone number so we can contact you if necessary",
  fillInTheDetailsAboutTheShippingService: "Fill in the details about the shipping service",
  saveTheModifiedInformation: "Save the modified information",
  afterFillingInAllTheInformation:
    "After filling in all the information, click save so that the information is saved",
  onThisPageYouWillConfigure: "On this page you will configure the details of your store",
  finallyOnThisPageYouWillRegisterYourProducts:
    "Finally, on this page you will register your products",
  publicKey: "public key",
  privateKey: "private key",
  accessWallet: "Access wallet",
  disconnectWallet: "Disconnect Wallet",
  notifications: "Notifications",
  noNotifications: "No notifications",
  StoresMap: "Stores Map",
  map: "Map",
  physicalStore: "Physical Store",
  payments: "Payments",
  payWithQrCode: "Pay with QR Code",
  payWithQrCodeDescription: "Point your camera to the payment QR Code.",
  createChargeWithQrCode: "Create charge",
  createChargeWithQrCodeDescription: "Create a charge by QR Code",
  paymentTransaction: "Do you want to make payment for this transaction?",
  pay: "Pay",
  transactionValue2: "Transaction Value",
  banners: "Banners",
  amountToBeReceived: "Amount to be received",
  discountPercentual: "Percentual discount",
  discountAbsolut: "Absolute discount",
  none: "None",
  percentual: "Percentual",
  minimalOrderValueToActivateSetting: "Minimal order value to activate setting",
  successSaveFreightRule: "Freight rule saved successfully",
  feightRules: "Freight Rules",
  setShippingRulesForYourStore: "Set shipping rules for your store.",
  newFringeBenefit: "New Voucher",
  newProduct: "New Product",
  listProducts: "List Products",
  listFringeBenefits: "List Voucher",
  video: "Video",
  dragVideoFile: "Drag video file here",
  videoUploadedSuccessfully: "Video uploaded successfully",
  videoNotSupported: "Your browser does not support video playback",
  uploadVideoMaxSize20MB: "Upload a video up to 20MB for your store",
  videoSizeExceeds20MB: "Video size exceeds 20MB",
  balanceAvailableForWithdrawal: "Balance available for withdrawal:",
  centralFinanceira: "Central Financeira",
  financialHubSubtitle: "Track and manage your Extraconomy wallet operations.",
  patrimonyConsolidated: "Consolidated patrimony",
  last30Days: "in the last 30 days",
  walletEuro: "WALLET",
  withdrawable: "WITHDRAWABLE",
  availableForWithdrawal: "Available for withdrawal",
  withdrawAction: "Withdraw",
  statement: "Statement",
  useInStore: "Use in store",
  extracredit: "Extracredit",
  consumption: "CONSUMPTION",
  purchasingPower: "purchasing power",
  quickOperations: "Quick Operations",
  transferECR: "Transfer ECR",
  financial: "Financial",
  overview: "Overview",
  transactions: "Transactions",
  lifetimeWalletId: "ID",
  lifetimeWalletEntry: "Entry",
  lifetimeWalletOutcome: "Outcome",
  bankAccounts: "Bank accounts",
  balanceSummary: "Balance summary",
  totalAvailable: "Total available",
  credit: "Credit",
  debit: "Debit",
  originOfFunds: "Origin of financial resources",
  transactionsCarriedOut: "Transactions carried out",
  withdrawals: "Withdrawals",
  requestWithdrawal: "Request withdrawal",
  dailyIncome: "Daily income",
  noBankAccountWarning: "No bank account registered. To request withdrawals, register an account.",
  bankAccountSettingsLink: "Bank account settings",
  requestWithdrawalButton: "Request withdrawal",
  history: "History",
  availableBalance: "Available balance",
  howToUseCredits: "How to use your credits",
  creditMovement: "Credit movement",
  comingSoon: "Coming soon",
  invest: "Invest",
  swap: "Swap",
  bankAccountFormTitle: "Bank account registration",
  bankAccountFormTitleEdit: "Edit bank account",
  bankAccountFormSubtitle: "Enter your account details.",
  identification: "Identification",
  mainAccount: "Main account",
  mainAccountHelp: "Check to set as main account.",
  bankDetails: "Bank details",
  accountType: "Account type",
  email: "Email",
  bankAccountRegister: "Register",
  registeringAccount: "Registering your account. Please wait.",
  invalidIban: "Invalid IBAN. Please check the number entered.",
  accountRegisteredSuccess: "Account registered successfully.",
  accountUpdatedSuccess: "Account updated successfully.",
  accountDeletedSuccess: "Account deleted successfully.",
  addAccount: "Add account",
  configure: "Configure",
  myAccounts: "My accounts",
  noAccountsMessage:
    "You don't have any bank accounts registered yet. Register a new account to make transfers.",
  transferTo: "Transfer to",
  selectAccount: "Select an account",
  processingWithdrawal: "Processing withdrawal...",
  cancel: "Cancel",
  save: "Save",
  principal: "Principal",
  delete: "Delete",
  confirmDeleteAccount: "Are you sure you want to delete this account?",
  attention: "Attention",
  yes: "Yes",
  no: "No",
  confirmWithdrawal: "Confirm withdrawal",
  searchByTransaction: "Search by transaction",
  filter: "Filter",
  transaction: "Transaction",
  operationType: "Operation type",
  registrationDate: "Registration date",
  noOperationsRecords: "Still no records of operations.",
  saleInStore: "Product sale in store",
  purchaseInStore: "Product purchase in store",
  register: "Register",
  paymentMethodExtracredit: "Extracredit",
  paymentMethodWallet: "Wallet balance",
  paymentMethodPayPal: "PayPal",
  paymentMethodBankTransfer: "Bank transfer",
  paymentMethodMultiple: "Multiple",
  pendingReceipts: "Pending receipts",
  pendingReceiptsSent: "sent",
  pendingReceiptsHint: "These values will only be credited after acceptance.",
  approve: "Approve",
  recipientSelection: "Recipient selection",
  recipientSelectionHint: "Select who will receive your transfer.",
  chooseRecipient: "Choose the recipient",
  searchRecipient: "Search recipient...",
  userNotFound: "This user was not found. Check the entered data and try again.",
  recipientDetails: "Recipient details",
  changeRecipient: "Change recipient",
  values: "Values",
  valuesHint: "Enter how much you wish to transfer to {name}.",
  available: "Available",
  enterAmount: "Enter the amount",
  platformFee: "Platform fee",
  transferSummary: "Transfer summary",
  transferSummaryHint: "Review and confirm before finalizing.",
  sendTo: "Send to",
  recipient: "Recipient",
  transferCompleted: "Transfer completed",
  goToStatement: "Go to statement",
  powerOfUse: "Power of use",
  powerOfUseDescription: "Pay up to {percent}% of your purchases using your Extracredit balance.",
  powerOfUseLabel: "You can use up to {percent}% of your ECR balance",
  powerOfUseManagerRule: "For each paid referral (not via voucher) you unlock 2%.",
  powerOfUseOtherRule: "For each paid referral you unlock 1%.",
  unlocked: "unlocked",
  goal: "Goal",
  unlockMore: "Unlock +",
  powerOfUseManagerUnlock: "Invite new Partners (paid, not via voucher) to increase your limit.",
  powerOfUseOtherUnlock: "Invite new paid Partners to increase your limit.",
  opportunitiesToUse: "Opportunities with Extracredits",
  accessStore: "Access store",
  completeStatement: "Complete statement",
  useCreditPercent: "Use {percent}% Credit",
  credits: "Credits",
  totalValue: "Total value",
  transferExtracredit: "Transfer Extracredit",
  transferExtracreditSubtitle: "Transfer Extracredits to other users in the Extraconomy ecosystem.",
  transferConfirmDisclaimerBefore: "By clicking ",
  sendCredits: "Send credits",
  transferConfirmDisclaimerMiddle: ", I grant ",
  companyExtraconomy: "Extraconomy",
  transferConfirmDisclaimerAfter: " permission to proceed with the detailed transaction.",
  securityValidationTitle: "Security validation",
  securityValidationEmailSent: "For your security, we sent a {length}-character code to {email}",
  securityValidationConfirmTransfer:
    "Enter the code to confirm the transfer of {amount} to {recipient}",
  securityValidationConfirmWithdrawal:
    "Enter the code to confirm the withdrawal of {amount} to {recipient}",
  securityValidationCodeExpires: "the code expires in {time}",
  securityValidationResend: "Resend code",
  securityValidationResendIn: "Resend code (in 5min)",
  securityValidationValidate: "Validate code",
  rejectNotAvailable: "Reject is not available.",
  search: "Search",
  toAgreeAndReceiveInsertCode: "To agree and receive, enter the code sent to your email:",
  confirmYourAction: "Confirm your action",
  seeDetails: "See details",
  whiteLabel: "White Label",
  whiteLabelSettingsTitle: "Appearance settings",
  whiteLabelSettingsSubtitle: "Customize the appearance settings of your dashboard.",
  whiteLabelSaveChanges: "Save changes",
  whiteLabelAssets: "Assets",
  whiteLabelLogo: "Logo",
  whiteLabelFavicon: "Favicon",
  whiteLabelChooseFile: "Choose file",
  whiteLabelClickToUpload: "Click to upload",
  whiteLabelOrDragDrop: "or drag and drop",
  whiteLabelFileFormatsLogo: "SVG, PNG, JPG or GIF (max. 400×400px)",
  whiteLabelFileFormatsFavicon: "SVG, PNG, JPG or GIF (max. 64×64px)",
  whiteLabelBrandColors: "Brand colors",
  whiteLabelPrimaryColor: "Primary color",
  whiteLabelSecondaryColor: "Secondary color",
  whiteLabelBackgroundColor: "Platform background",
  whiteLabelTextColor: "Text color",
  whiteLabelTypography: "Typography",
  whiteLabelFont: "Font",
  whiteLabelSelectFont: "Select font",
  whiteLabelImageUploaded: "Image uploaded successfully",
  whiteLabelThemeCreated: "Theme created successfully",
  whiteLabelThemeUpdated: "Theme updated successfully",
  whiteLabelChangesReset: "Changes reset to defaults",
  whiteLabelDefaultSettings: "Default settings",
  whiteLabelCustomNetworkDefault: "Custom network",
  whiteLabelPrimaryColorHelp:
    "Represents your brand identity. It will be used for action buttons, active links and the most important elements.",
  whiteLabelSecondaryColorHelp:
    "A secondary color to create contrast. It will appear in badges, background icons and secondary visual details.",
  whiteLabelBackgroundColorHelp:
    "The predominant color behind the content. We recommend light tones (such as white or light gray) for easier reading.",
  whiteLabelTextColorHelp:
    "Defines the color of titles and paragraphs. Choose a dark tone that contrasts well with the platform background.",
  whiteLabelFontHelp:
    "The typography family that will give voice to your platform. Choose a readable font that aligns with your brand image.",
  whiteLabelLogoPreview: "Logo preview",
  whiteLabelFaviconPreview: "Favicon preview",
  myCards: "My Cards",
  myCardsSubtitle: "View and manage your virtual cards.",
  myCardsEmpty: "No cards available.",
  myCardsClickToFlip: "Click the card to flip it",
  myCardActive: "Active",
  myCardInactive: "Inactive",
  orderSingular: "order",
  orderPlural: "orders",
  awaitingProcessing: "Awaiting processing",
  noPending: "None pending",
  managerDashboardErrorLoad: "Error loading dashboard data",
  managerStoreStatusPending: "Pending",
  managerNetworkLevelSenior: "Senior",
  managerWalletChangeVsPrevious: "+2% vs previous month",
  managerBalanceSales: "sales",
  managerTrackStoreHere: "Track your store here.",
  managerBilling: "BILLING",
  managerInProcessing: "in processing",
  managerLiveStore: "LIVE STORE",
  managerNetworkEarnings: "NETWORK EARNINGS",
  managerNetworkLevelLabel: "Network level",
  managerTotalEarnings: "Total earnings",
  managerB2bPurchasingPower: "B2B purchasing power",
  managerBonusAds: "Bonus ADS",
  managerAdsForExternalAds: "ads for external ads",
  managerFooterCompanyName: "EXTRACONOMY GLOBAL srl",
  managerFooterAddress: "Via Nomentana, 1018 - 00137 Roma (IT)",
  managerFooterTaxInfo: "VAT and Tax ID 16948681008",
  managerFooterRea: "REA 1686351",
  economicCircle: "Economic Circle",
  economicCircleSubtitle: "Track your economic circle and expansion.",
  invite: "Invite",
  inviteSubtitle: "Invite members and expand your network of influence.",
  currentStatus: "Current status",
  members: "Members",
  networkPower: "Network power",
  activeInfluence: "Active influence",
  networkEarnings: "Network earnings",
  thisMonth: "this month",
  totalAccumulatedLifetime: "Total accumulated (Lifetime)",
  directCommission: "Direct commission",
  networkCommission: "Network commission",
  networkHighlightsTop5: "Network highlights (Top 5)",
  recentMembers: "Recent members",
  viewAll: "View all",
  transactionHistory: "Transaction history",
  noRecentMembers: "No recent members.",
  origin: "Origin",
  type: "Type",
  date: "Date",
  value: "Value",
  paid: "Paid",
  goalForGold: "Goal for GOLD",
  copied: "Copied",
  copiedToClipboard: "Copied to clipboard",
  qrcodereferralLinks: "QR Code of referral links",
  referralLinksExplanation: "Log in to generate referral links.",
  share: "Share",
  directMembers: "Direct members",
  indirectMembers: "Indirect members",
  totalReceived: "Total received",
  withdrawalsMade: "Withdrawals made",
  membersAndTransactions: "Members and transactions",
  membersAndTransactionsSubtitle: "Members and transactions of your circle.",
  searchByMember: "Search by member",
  indirects: "Indirect",
  noMembers: "No members.",
  name: "Name",
  actions: "Actions",
  completed: "Completed",
  pending: "Pending",
  canceled: "Canceled",
  active: "Active",
  inactive: "Inactive",
  activeDigitalAssets: "Active digital assets",
  privacyPolicy: "Privacy Policy",
  managerMobileNavOpenMenu: "Open menu",
  partnerB2bTitle: "Partner B2B",
  partnerB2bSubtitle: "Find and connect with strategic partners in your region.",
  partnerB2bSearchPlaceholder: "ATECO codes or activity areas...",
  partnerB2bRadiusLabel: "Radius",
  partnerB2bRadiusKm: "km",
  partnerB2bSearch: "Search",
  partnerB2bAddressWarningText:
    "You need to configure your position (postal code and address) to use geolocalized search.",
  partnerB2bConfigurePosition: "Configure position",
  partnerB2bEmptyState:
    "No results were found with the current criteria. Try widening the search radius or removing some filters.",
  partnerB2bSubnetOnly: "This page is only available for subnet members.",
  partnerB2bContact: "Contact",
  partnerB2bActivities: "Activities / ATECO",
  partnerB2bContactPartner: "Contact partner",
  partnerB2bGetDirections: "Get directions",
  partnerB2bDistanceFromYou: "{km} km from you",
  partnerB2bClosestPartners: "Closest partners",
  partnerB2bShowingResultsInRadius: "Showing {count} {countLabel} within {radius} km",
  partnerB2bResult: "result",
  partnerB2bResults: "results",
  partnerB2bWaitingForSearch: "Waiting for a search to list partners.",
  partnerB2bNoPartnersFound: "No partners found for the current filters.",
  partnerB2bFromYou: "from you",
  partnerServicesTitle: "Partner services",
  partnerServicesTabBusiness: "Services for businesses",
  partnerServicesTabIndividuals: "Services for individuals",
  partnerServicesActivateService: "Activate service",
  partnerServicesAwaitingFeedback: "Awaiting feedback",
  partnerServicesServiceActivated: "Service activated successfully",
  partnerServicesServiceActivationFailed: "Failed to activate service",
  partnerServicesMenuLabel: "Partner services",
  backToFedernet: "Back to Association",
  performanceChartLabel: "Commercial Performance",
  performanceChartTitle: "Commercial performance",
  performanceChartErrorLoadingData: "Error loading data",
  performanceChartLoading: "Loading...",
  accessCommercialDashboard: "Access commercial dashboard",
  recentOperations: "Recent operations",
  recentOperationsJustNow: "Just now",
  recentOperationsMoreItems: "(+{count})",
  recentOperationsCustomerEmptyState: "You have not made any purchase operations yet.",
  recentOperationsExploreStore: "Explore the Extraconomy store",
  customerHomeExtracreditBalanceTitle: "Extracredit Balance (ECR)",
  customerHomeExtracreditEquivalent: "Equivalent to ~ {value} in the network",
  customerHomePendingTransactionsTitle: "Pending transactions",
  customerHomePendingTransactionsSubtitle: "View your orders",
  customerHomeQuickActionsTitle: "Quick actions",
  customerHomeExploreStores: "Explore stores",
  customerHomeFutureTitle: "Coming soon: new features for Customers.",
  customerHomeFutureSubtitle:
    "We are preparing new resources to expand purchasing and service possibilities in your dashboard.",
  customerHomeFutureImageAlt: "Customer informational section",
  myPurchases: "My purchases",
  myPurchasesSubtitle: "Follow your purchases and the status of each order.",
  totalPurchases: "Total purchases",
  lastPurchaseDate: "Last purchase",
  noPurchases: "No purchases yet",
  searchByIdOrSeller: "Search by ID or seller",
  partnerStoresMenuLabel: "Partner stores",
  upgradePageNotAvailableTitle: "Upgrade unavailable",
  upgradePageNotAvailableDescription: "This profile currently has no upgrade options available.",
  upgradePageHeadlineCustomer: "Unlock your earning potential",
  upgradePageHeadlinePartner: "Scale your business in e-commerce",
  upgradePageHeadlineSeller: "Dominate your territory with geolocation",
  upgradePageHeadlineStore: "Start your e-commerce growth",
  upgradePageSubheadlineCustomer:
    "Become a Partner or Manager to unlock the career plan and generate concrete income in our ecosystem.",
  upgradePageSubheadlinePartner:
    "Activate the StartSeller plan and bring your physical store online, going beyond geographic boundaries.",
  upgradePageSubheadlineSeller:
    "Migrate to the Manager profile to automatically receive customers from your area through our app.",
  upgradePageSubheadlineStore:
    "Activate the Start Seller plan to unlock online sales and product publishing in the marketplace.",
  upgradePaymentTitle: "Complete upgrade",
  upgradeMostPopular: "most chosen",
  upgradePlanNamePartner: "PARTNER",
  upgradePlanNameSeller: "SELLER",
  upgradePlanNameManager: "MANAGER",
  upgradePlanNameStartSeller: "START SELLER",
  upgradePlanDescriptionPartner: "For those starting to sell online.",
  upgradePlanDescriptionSeller: "For those who want to increase their sales.",
  upgradePlanDescriptionManager: "For those who want to expand their business.",
  upgradePlanDescriptionStartSeller: "For those who want to increase their sales.",
  upgradeFeatureStorefront: "Online storefront",
  upgradeFeatureEconomicCircle: "Economic circle",
  upgradeFeatureNoMonthlyFee: "No monthly fees",
  upgradeFeaturePersonalEcommerce: "Personal e-commerce",
  upgradeFeatureDropshipping: "Includes dropshipping",
  upgradeFeatureOnlineStore: "Online store",
  upgradeFeatureGeolocationActive: "Active geolocation",
  upgradeFeatureAllIncluded: "All included",
  upgradeStartSellerRenewal: "Yearly renewal: EUR 35.00",
  storeActivateStartSellerWarning:
    "To publish products, activate the Start Seller plan in the account upgrade.",
  storeActivateStartSellerCta: "Enable Online Sales Start Seller",
  productLimitReached:
    "You have reached your plan limit of {limit} listings. Upgrade your plan to add new listings.",
  storeProductsLimitWarning:
    "You have reached your plan limit of {limit} listings. Upgrade to keep adding products and services.",
  paymentsPysicalStore: "Payments of the physical store",
  payPhysicalStore: "Pay physical store",
  physicalStoreProofSubmitted: "Proof submitted, awaiting validation.",
  securityCodeLabel: "Security code (sent to your e-mail):",
  securityCodeSend: "Send code",
  securityCodeResend: "Resend code",
  securityCodeHint: "Click \"Send code\" and enter the code you receive by e-mail. Each new code invalidates the previous one.",
  securityCodeSent: "Code sent! Check your e-mail.",
  securityCodeCantBeEmpty: "Enter the security code sent to your e-mail.",
  securityCodeIsWrong: "Invalid or expired security code.",
};

export default userDashboardDictEN;
